module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Confirm the placement of the map pin."), _c('br'), _c('small', {
    staticClass: "font-grey-mint"
  }, [_vm._v("Drag the map marker to your location if the coordinates are not correct")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "25px",
      "margin-top": "25px",
      "height": "300px"
    },
    attrs: {
      "id": "map"
    }
  }, [_vm._v("There was an issue loading the map. Please try again.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d558c762!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/GoogleMapsPinConfirmation.vue
// module id = 459
// module chunks = 1